import { createRoot } from "react-dom/client";
import "./main.css";
import "./utils/i18n/index.ts";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(<App />);
